module.exports = __webpack_public_path__ + "img/loginbackground.0e4b230a.jpg";